import React, { useState, useCallback } from 'react';
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from '@react-google-maps/api';
import { IntlProvider, FormattedDate, FormattedTime } from 'react-intl'
import Globals from '../../utils/globals';
import MarkerOpen from './marker-open.svg'; // xt this was used for testing
import MarkerSingle from './marker-single.svg'; // xt this was used for testing

// xt these are to define the component path to the file. REACT webpack needs it done like this to get the correct path
// each one of these files are a differnt color pin.. 
// xt there might be a better way to do this using css or varible sustituions on the url line in Marker but it was
//    a hassle to implement and then would be harder to understand later to see what was going on. this is straight forward
//   xt: NOTE: this means that each agency may have different colors for the same incidnet since they are listed
//        in different orders in the DB, under "reports.items" but each agency will keep the same colors per inc type
import Marker0 from './marker0.svg';
import Marker1 from './marker1.svg';
import Marker2 from './marker2.svg';
import Marker3 from './marker3.svg';
import Marker4 from './marker4.svg';
import Marker5 from './marker5.svg';
import Marker6 from './marker6.svg';
import Marker7 from './marker7.svg';
import Marker8 from './marker8.svg';
import Marker9 from './marker9.svg';
import Marker10 from './marker10.svg';
import Marker11 from './marker11.svg';
import Marker12 from './marker12.svg';
import Marker13 from './marker13.svg';
import Marker14 from './marker14.svg';
import Marker15 from './marker15.svg';
import Marker16 from './marker16.svg';

// xt NOTE: the array can NOT handle the paths directly in the array due to webpack issues with file under /src
const MarkerIconArray = [
  Marker0,
  Marker1,
  Marker2,
  Marker3,
  Marker4,
  Marker5,
  Marker6,
  Marker7,
  Marker8,
  Marker9,
  Marker10,
  Marker11,
  Marker12,
   Marker13,
  Marker14,
  Marker15,
  Marker16,
 ];


/// xt GROK SUGGESTION..SAMPLE..
// const MarkerIconArray = [
//   'path/to/icon1.svg',
//   'path/to/icon2.svg',
//   'path/to/icon3.svg',
//   // ... other icon URLs
// ];

// {icons[i] && (
//   <Marker
//     key="singleMarker"
//     position={coords.coordinates}
//     icon={{ url: icons[i] }}
//     title={coords.type}
//   />
// )}

/// END GROK SAMPLE.. I AM TRYING TO USE..
// google says we need these values for the map to be rendered correctly. My modal is set to 600px height
// const containerStyle = {
//   width: '100%',
//   height: '1000px',
// };

// const locations = [ // xt sample from chatgpt
//   { lat: 37.7749, lng: -122.4194, type: 'San Francisco' },
//   { lat: 34.0522, lng: -118.2437, type: 'Los Angeles' },
//   { lat: 40.7128, lng: -74.0060, type: 'New York' },
// ];

const MapNewGoogle = (props) => {
    const {coords, center}=props
    console.log("coords", coords)
    console.log('mapnewgoogle-center, ', center)
    //console.log("this is MarkerSingle ", MarkerSingle);
    
   
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: Globals.googleMapsApiKey  // use global API key
  });

  // from grok
  let centerpoint;
  centerpoint = center;

// if (Array.isArray(coords) && coords.length > 0) {
//     // If coords is an array and has at least one element, use the first element's coordinates
//     centerpoint = coords[0].coordinates;
// } else if (typeof coords === 'object' && coords !== null) {
//     // If coords is an object (but not an array), use its coordinates property directly
//     centerpoint = coords.coordinates;
// } else {
//     // If coords is neither an array nor an object, or if it's an empty array, you might want to set center to null or handle it appropriately
//     centerpoint = null;
// }
  //
  const [selectedMarker, setSelectedMarker] = useState(null);

  const onMarkerClick = useCallback((marker) => {
    setSelectedMarker(marker);
  }, []);

  const onCloseClick = () => {
    setSelectedMarker(null);  // Close InfoWindow when the close button is clicked
  };
 

  return isLoaded && coords ? (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '800px' }}
      center={centerpoint}
    //   center={coords[0].coordinates  }  // Center of the map is [0] for old google map
      zoom={10}
      options={{
      gestureHandling: "greedy",
      zoomControl: true,
      scrollwheel: true,
  }}
    >
      {/* {coords.map((coord, index) => ( // xt look up map and params
        <Marker
          key={index}
          position={coord.coordinates}
          title={coord.type}
          onClick={() => onMarkerClick(coord)}  // Show InfoWindow for this marker
        />
      ))} */}
      {Array.isArray(coords) ? (
  coords.map((coord, index) => (
    
    <Marker
      key={index}
      position={coord.coordinates}
      icon={{ url: MarkerIconArray[coord.typeOffset],  // this works, but using the path here, or the offest not wk
      scaledSize: new window.google.maps.Size(50, 50),
      anchor: new window.google.maps.Point(15, 40)

      }}
      //icon={{ url: MarkerIconArray[coord.typeOffset] }} // xt should resolve to a MarkerX name but doesnt
      title={coord.type}
      onClick={() => onMarkerClick(coord)}  // Show InfoWindow for this marker
    />
  ))
) : (
  // Assuming coords is an object with coordinates and type properties
  <Marker
    key="singleMarker"
    position={coords.coordinates}
    icon={{
      url: MarkerSingle, // xt this cant take arguements, it would need to be in a wrapper component
      scaledSize: new window.google.maps.Size(50, 50), // Match your SVG dimensions
      anchor: new window.google.maps.Point(15, 40) // Adjust based on your SVG's anchor point xt need to ck this
    }}
    title={coords.type}
    onClick={() => onMarkerClick(coords)}  // Show InfoWindow for this marker
  />
)}

      {/* InfoWindow for the selected marker */}
      {selectedMarker && (
        <InfoWindow
          position={selectedMarker.coordinates}
          onCloseClick={onCloseClick}
        >
          <div>
            
            { selectedMarker.incident_number &&
              <div className='text-medium'><h1>{selectedMarker.incident_number}</h1></div> 
            }
            { selectedMarker.type &&
              <div className='text-small'><h2>{selectedMarker.type}</h2></div> 
            }
           {/* { selectedMarker.description &&
              <div className='text-medium'>{selectedMarker.description} </div>
            } */}
            { selectedMarker.location &&
              <div className='text-small'>{selectedMarker.location}</div> 
            }
            <div className='history-times text-small'>
              <IntlProvider locale='en'>
                <span>Occurred at:  
                  <FormattedDate value={selectedMarker.occurred || Date.now()} month='numeric' day='numeric' year='2-digit' />
                  <FormattedTime value={selectedMarker.occurred || Date.now()} hour12={false} />
                </span>
              </IntlProvider>
            </div>
            { selectedMarker.coordinates.lat && selectedMarker.coordinates.lng &&
              <div className='text-small'>gps= Lat:{selectedMarker.coordinates.lat} Long:{selectedMarker.coordinates.lng} </div> 
            }
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
      
      

  ) : <div>Loading Map...</div>;
};

export default MapNewGoogle;
